<template>
  <button :class="{ isActive }">
    <img :src="menuSvg.src" alt="Menu">
  </button>
</template>

<script setup>
import menuSvg from '~/assets/site-nav/menu.svg'
const { isActive } = defineProps({ isActive: Boolean })
</script>

<style scoped>
.isActive {
  transform: scaleX(-1);
}
</style>
